import type { BidType, ManualAcceptFlow, MarketProgram } from '@/features/bidding/constants'
import { bidTypeToSlug, marketProgramToSlug } from '@/features/bidding/utils/bidDetail/routeSlugs'
import type { MarketDate } from '@/features/bidding/utils/date/marketDate'

export type GroupedBidParams = {
  deliveryDay: MarketDate
  portfolioCode: string
  marketProgram: MarketProgram
  bidType: BidType
}

export const buildBidEditLink = (manualAcceptFlow: ManualAcceptFlow, params: GroupedBidParams): string =>
  buildLinkWithBidLinkParameters(`/bidding/manual-accept/${manualAcceptFlow}?`, params)

export const buildBidViewLink = (params: GroupedBidParams): string =>
  buildLinkWithBidLinkParameters(`/bidding/view?`, params)

export const buildBidDetailLink = (params: GroupedBidParams): string => {
  const query = new URLSearchParams({
    portfolioCode: params.portfolioCode,
    deliveryDay: params.deliveryDay.toISODate(),
  })

  return `/bidding/${marketProgramToSlug(params.marketProgram)}/${bidTypeToSlug(params.bidType)}?${query.toString()}`
}

export const buildBidCapacityLink = (params: GroupedBidParams): string =>
  buildLinkWithBidLinkParameters('/bidding/offer/create/capacity?', params)

export const buildBidConfirmationLink = (params: GroupedBidParams): string =>
  buildLinkWithBidLinkParameters('/bidding/offer/confirm/capacity?', params)

export const buildBidPriceConfirmationLink = (params: GroupedBidParams): string =>
  buildLinkWithBidLinkParameters('/bidding/offer/confirm/price?', params)

export const buildBidPriceLink = (params: GroupedBidParams): string =>
  buildLinkWithBidLinkParameters('/bidding/offer/create/price?', params)

const buildLinkWithBidLinkParameters = (link: string, params: GroupedBidParams): string => {
  link += `marketProgram=${params.marketProgram}`
  link += `&deliveryDay=${params.deliveryDay.toISODate()}`
  link += `&portfolioCode=${params.portfolioCode}`
  link += `&bidType=${params.bidType}`
  return link
}
